import axios from 'axios';

let route;
if (process.env.NODE_ENV === 'development') {
  route = process.env.VUE_APP_SCREEN_DATA_DEV_URL;
} else {
  route = process.env.VUE_APP_SCREEN_DATA_PROD_URL;
}
const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export function getScreenStats(uuid) {
  return api.get(`${route}/getItemInfo/${uuid}`);
}

export function getAllScreenItems(tableName) {
  return api.get(`${route}/getScreens/${tableName}`);
}

export function getScreensByGroup(groupId) {
  return api.get(`${route}/getScreensByGroup/${groupId}`);
}
